import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from 'Src/consts/report';
import {
  ReportActions,
  ReportDateRange,
  ReportDescription,
  ReportSection,
  ReportToggle,
  ReportToggleList
} from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';
import '../../Users.css';

interface Props {
  onCloseClick: () => void;
  onSubmit: (data: any, reportType: string) => void;
}

// report 025
export function ParentActivityReportForm(props: Props) {
  const now = new Date();
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);

  return (
    <Formik
      initialValues={{ dateFrom: yesterday, dateTo: now, isShowZero: true, isShowNonZero: true }}
      onSubmit={values => props.onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.PARENT_ACTIVITY)}
    >
      {({ values, setFieldValue }) => (
        <Form className="eReportForm">
          <ReportDescription>Review parent platform activity for a chosen period.</ReportDescription>
          <ReportSection
            number={1}
            title="Reporting period"
            hint="Choose the date range included in the report."
            required
          >
            <ReportDateRange
              dateFrom={values.dateFrom}
              dateTo={values.dateTo}
              onChangeFrom={date => {
                setFieldValue('dateFrom', date);
                if (values.dateTo < date) setFieldValue('dateTo', date);
              }}
              onChangeTo={date => setFieldValue('dateTo', date)}
            />
          </ReportSection>
          <ReportSection
            number={2}
            title="Parents to include"
            hint="Choose which activity groups appear in the report."
          >
            <ReportToggleList>
              <ReportToggle
                name="isShowZero"
                label="Parents without activity"
                hint="Include parents who did not log in during the selected period."
                value={values.isShowZero}
                onChange={value => setFieldValue('isShowZero', value)}
              />
              <ReportToggle
                name="isShowNonZero"
                label="Parents with activity"
                hint="Include parents who logged in during the selected period."
                value={values.isShowNonZero}
                onChange={value => setFieldValue('isShowNonZero', value)}
              />
            </ReportToggleList>
          </ReportSection>
          <ReportActions onCancel={props.onCloseClick} disabled={!values.isShowZero && !values.isShowNonZero} />
        </Form>
      )}
    </Formik>
  );
}
